import { render } from "./ListePatient.vue?vue&type=template&id=333ef039"
import script from "./ListePatient.vue?vue&type=script&lang=js"
export * from "./ListePatient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__